import React from 'react';
import styled, { ThemeProvider, keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

import { theme } from '../lib/styles';

const wiggle = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(-4deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(4deg);
  }
`;

const Num = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%) rotate(-8deg);
  font-size: 50vh;
  color: rgba(0,0,0,0.02);
  font-weight: bold;
  animation: ${wiggle} 5s ease-in-out infinite alternate;
  will-change: transform;
`;

const Notification = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 200px;
  border-radius: 8px;
  background: white;
  box-shadow: 0px 4px 32px -16px rgba(0,0,0,0.4);
  padding: 40px;
	display: flex;
	flex-direction: column;
  align-items: center;
	justify-items: center;
  align-content: center;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  color: ${props => props.theme.brand};
`;

const NotFound = props => {
	return (
		<React.Fragment>
			<ThemeProvider theme={theme}>
				<React.Fragment>
					<Num>404</Num>
					<Notification>
						<p>Pyydettyä reittiä ei löytynyt :(</p>
						<StyledLink to="/">Palaa takaisin kohdelistaukseen.</StyledLink>
					</Notification>
				</React.Fragment>
			</ThemeProvider>
		</React.Fragment>
	);
};

export default NotFound;
